<template>
  <div>
    <div class="string">
      <div class="fields custom">
        <div class="validation-wrapper phone">
          <div class="order-input phone">
            <PhoneInput ref="phoneInput" :phone="phone" @update:phone="phone = $event" />
          </div>
          <ValidationView :errorMessages="getErrorMessages('phone')" />
        </div>
        <template v-if="this.$store.getters.isYandexForm">
          <template v-if="isFirstDot">
            <Date :dot="dot" />
            <TimeFrom :dot="dot" />
          </template>
        </template>
        <template v-else>
          <Date :dot="dot" />
          <TimeFrom :dot="dot" />
          <TimeTo :dot="dot" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import detailsMixins from '@apps/order-form/src/mixins/dotDetails'
import PhoneInput from '@features/PhoneInputWithValidation.vue'
import Date from './times/Date.vue'
import TimeFrom from './times/TimeFrom.vue'
import TimeTo from './times/TimeTo.vue'

export default {
  name: 'DetailsComponent',
  mixins: [detailsMixins],
  components: {
    Date,
    TimeFrom,
    TimeTo,
    PhoneInput,
  },
}
</script>
